import {useEffect} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";

export const AdminsHireSignupViewNoteModal = (props: { active: boolean, closeHandler: any,name:string,note:string,title:string }) => {
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>{props.title}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <p style={{color:'#000',fontSize:16,lineHeight:'30px'}}>{props.note}</p>
                    </div>
                </div>
            </div>
        </>
    );
};